import React from "react";
import { useEffect } from 'react';
function TermsandConditions() {

    useEffect(() => {
            window.scrollTo(0, 0);
          }, []);

  return (
    <section className="product_damage_return_policy_section pt-40 pb-40">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="inner-box">
              <h5>Introduction and Acceptance of the Terms and Conditions</h5>
              <p>
                The general Terms and Conditions of Sale detailed below govern
                the contractual relationship between the ‘User’ (hereafter also
                referred to as ‘You’ or the ‘Customer’) and ‘[AAMMII THARCHARBU
                SANTHAI THARCHARBU SANTHAI]’ (hereafter also referred to as ‘We’
                or the ‘Website’), belonging to the AAMMII THARCHARBU SANTHAI
                THARCHARBU SANTHAI, +6012 3544988.
                Product delivery duration: Delivery within 7 business days.
              </p>

              <p>
                Both parties accept these Conditions unreservedly. These general
                Conditions of Sale are the only conditions that are applicable
                and replace all other conditions, except in the case of express.
                written, prior dispensation. We maintain that, by confirming
                your order, you have read and do unreservedly accept our general
                Conditions of Sale. These Terms and Conditions of Sale are
                important to you and [AAMMII THARCHARBU SANTHAI THARCHARBU
                SANTHAI] as they are used to protect your rights as a valued
                customer and our rights as a business.
              </p>
            </div>

            <div className="inner-box">
              <h5>Changes to the Terms of Service and the Website</h5>
              <p>
                [AAMMII THARCHARBU SANTHAI] is a work in progress, and as such
                things may change, be added or be taken away. We reserve the
                right to update the Website and these Terms of Service from time
                to time, at our discretion and without any notice. It is solely
                your responsibility to keep up-to-date with the latest Terms and
                Conditions by checking back regularly. Your continued use of the
                Website following the publishing of updated Terms of Service
                will be taken to mean that you have read and agree to the
                changes.
              </p>
            </div>

            <div className="inner-box">
              <h5>Access to the Website</h5>
              <p>
                We work hard to ensure the Website is always up and available,
                but we can't guarantee that the Website will not have downtime
                for any reason. We reserve the right to close the Website for
                short periods of time for general maintenance, but will attempt
                to keep this to a minimum. We will not be liable if for any
                reason all or any part of the Website is unavailable at any
                time, for any length of time.
              </p>
              <p>
                Parts of the Website require you to input a password to access
                certain features. This is to be able to give you details
                relevant to your order whilst still keeping them private to you.
                To do this, as part of our security procedures, we require you
                to register an account with [AAMMII THARCHARBU SANTHAI] by
                entering your email and choosing a secure password. We highly
                recommend that you choose a strong password that is hard for
                others to guess, and you log out from your account at the end of
                every session. There is a password reset procedure in case you
                forget your password. You must treat your account log-in
                information as confidential, not disclosing it to any third
                party and only using [AAMMII THARCHARBU SANTHAI] in person. If
                you think there may have been any breach of security then it is
                your responsibility to notify us immediately and if log-in is
                possible, to change your password.
              </p>
              <p>
                It is a condition of your use of the Website that all the
                information you provide on the Website is correct, current and
                complete. We reserve the right to disable any user account in
                our sole discretion, at any time for any or no reason, including
                if, in our opinion, you have failed to comply with any provision
                of these Terms of Service.
              </p>
              <p>
                We do not guarantee that the Website or any content provided on
                the Website is error free. We manage your personal data
                according to our Privacy Policy.
              </p>
            </div>

            <div className="inner-box">
              <h5>Product information</h5>
              <p>
                [AAMMII THARCHARBU SANTHAI] takes great care when putting
                product information, descriptions and images on-line but will
                not be held responsible for any mistakes or omissions to any
                information given.
              </p>
            </div>

            <div className="inner-box">
              <h5>Prices</h5>
              <p>
                The prices indicated on [AAMMII THARCHARBU SANTHAI] are shown in
                Pound Sterling and do not include delivery. The delivery costs
                are clearly shown and invoiced at the end of the order in
                addition to the price of the products. We reserve the right to
                modify our prices at any moment but this will be indicated to
                you on the order at the time the order is placed. If an
                obviously incorrect price appears on our website and is not
                corrected on your total at the time of order completion, for
                whatever reason (human error, technical error etc.), your order
                will be cancelled and the payment refunded to you, even if it
                has been initially validated.
              </p>
            </div>

            <div className="inner-box">
              <h5>Availability</h5>
              <p>
                We will always endeavour to fulfil your order once completed and
                paid for. If a product should become unavailable after your
                order has been confirmed and paid for, we will refund the price
                you paid for the product within 30 days following the date of
                payment. If your order includes products that are temporarily
                unavailable, we will send the available products out first and
                will follow with the outstanding items once they are available
                again. We will refund the shipping fees for the rest of the
                order. If relevant, we will offer you a replacement for an
                unavailable product, a product of equal price and quality. If
                you accept the replacement, and then wish to return it to us in
                the conditions outlined under Right of Return, the return
                postage will be covered by us. If you choose to decline this
                offer, and the original product is permanently unavailable, we
                will reimburse the price of the unavailable product.
              </p>
            </div>

            <div className="inner-box">
              <h5>Secure payment</h5>
              <p>
                [AAMMII THARCHARBU SANTHAI] currently offers one way to pay for
                your order, PayuMoney. These payment options use advanced SSL
                encryption to keep your transaction secure and do not cost you
                anything to use ([AAMMII THARCHARBU SANTHAI] is charged as the
                seller, you are not charged as the buyer) so you will not pay
                any extra for your order. You do not need to hold an account
                with these Merchants to use these methods of payments. Please
                refer to PayuMoney for full terms and conditions of use.
              </p>
            </div>

            <div className="inner-box">
              <h5>Delivery</h5>
              <p>
                Your order will be delivered to the address you indicated when
                your order was placed. The products bought on [AAMMII THARCHARBU
                SANTHAI] will be delivered to one address in mainland Across
                Malaysia. We do not deliver to the Channel Islands, or to other PO
                Box addresses.
              </p>
              <p>
                [AAMMII THARCHARBU SANTHAI] does everything in its power to
                respect the delivery times indicated on the website. We cannot,
                however, be held responsible for the consequences of a late
                delivery or the loss of a package caused by a third-party
                contracted to make delivery, or by you, or because of some
                unforeseen event or an Act of God. In the event where you do not
                receive your package, an investigation will be conducted with
                the carrier and may take several days upon receipt of your
                claim. During this period of investigation, no reimbursement or
                re- delivery will take place.
              </p>
            </div>

            <div className="inner-box">
              <h5>Right of Return </h5>
              <p>
                [AAMMII THARCHARBU SANTHAI] not allows you to return a product
                that you are orders. We will replace the product when it’s
                damaged by our service otherwise we won’t replace any products.
                When human errors make our products wrong we will replace with
                transportation charges.
              </p>
            </div>

            <div className="inner-box">
              <h5>Privacy and protection of personal data</h5>
              <p>
                The details you give us are essential for the processing and
                delivery of your orders, for billing and for the establishment
                of warranty contracts, therefore failure to provide these
                details will result in the cancellation of your order. By
                registering on the Site, you agree to provide us with sincere
                and true information as it concerns you. Communicating false
                information is contrary to the present general Terms and
                Conditions.
              </p>
              <p>
                You have the permanent right to access and rectify all the
                information that concerns you, in accordance with European texts
                and national laws in place (article 34 of the law of 6 January
                1978). You can at any time make a request to [AAMMII THARCHARBU
                SANTHAI] to find out what personal information we hold
                concerning you. You may at any time, and by request, modify this
                information.
              </p>
              <p>
                Cookies record certain information stored on your hard drive.
                This information enables us to generate statistics based on data
                from visitors to our site and suggest products that might
                interest you according to the items that you selected when you
                previously visited the site. Cookies do not contain any
                confidential information about you.
              </p>
            </div>

            <div className="inner-box">
              <h5>Intellectual ownership</h5>
              <p>
                All the content on [AAMMII THARCHARBU SANTHAI] website
                (illustrations, texts, names, brand names, images and videos) is
                the property of [AAMMII THARCHARBU SANTHAI]. Any partial or
                total reproduction of this content, by any means and on any
                support, is subject to prior and express authorisation by
                [AAMMII THARCHARBU SANTHAI]. All information, content and files
                is protected by International law concerning intellectual
                ownership and copyright.[AAMMII THARCHARBU SANTHAI] cannot give
                you the right to copy, display or distribute content that you do
                not have the intellectual rights to. All fraudulent use of this
                content that violates the rights held by a third party
                constitutes an offence of forgery, which is severely punished
                under the Intellectual Property Code.
              </p>
              <p>
                [AAMMII THARCHARBU SANTHAI] will not, under any circumstances,
                be held responsible if a user violates rights held by a third
                party through his activities on the site.
              </p>
            </div>

            <div className="inner-box">
              <h5>Waiver and Severability</h5>
              <p>
                Any failure of [AAMMII THARCHARBU SANTHAI] to exercise or
                enforce any right or provision of the Terms of Service shall not
                constitute a waiver of such right or provision. The Terms of
                Service constitutes the entire agreement between you and [AAMMII
                THARCHARBU SANTHAI], and governs your use of the service,
                superseding any prior agreements (including, but not limited to,
                any prior versions of the Terms of Service). If any provision of
                these Terms of Service is held by a court of competent
                jurisdiction to be invalid, illegal or unenforceable for any
                reason, such provision shall be eliminated or limited to the
                minimum extent such that the remaining provisions of the Terms
                of Service will continue in full force and effect.
              </p>
            </div>

            <div className="inner-box">
              <h5>Feedback & Comments</h5>
              <p>
                Any opinions left on the Website by [AAMMII THARCHARBU SANTHAI]
                customers are screened and moderated by [AAMMII THARCHARBU
                SANTHAI] . If the comments infringe on the law or are
                inappropriate (abusive publicity, defamation, insults, out of
                context commentary…), [AAMMII THARCHARBU SANTHAI] reserves the
                right to refuse or modify it.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TermsandConditions;
